import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-dot",
  templateUrl: "./med-icon-dot.component.html",
})
export class MedIconDotComponent extends SvgMixinComponent {}
